module.exports = __webpack_public_path__ + "static/img/chain-height-bg.9fcf3fcc.png";